import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import HeaderPrimary from 'flarum/forum/components/HeaderPrimary';
import IndexPage from 'flarum/forum/components/IndexPage';
import LinkButton from 'flarum/common/components/LinkButton';
import Page from 'flarum/common/components/Page';
import Modal from 'flarum/common/components/Modal';
export default function experience() {
  let lastMessage = '',
    lastAt = 0;
  const show = message => {
    if (message === lastMessage && Date.now() - lastAt < 1500) return;
    lastMessage = message;
    lastAt = Date.now();
    app.alerts.show({
      type: 'error'
    }, message);
  };
  const installFeedback = function () {
    for (const name of ['error', 'dashboardError', 'gameRolesError']) {
      let value = null;
      Object.defineProperty(this, name, {
        configurable: true,
        get() {
          return value;
        },
        set(next) {
          value = next;
          if (typeof next === 'string' && next) {
            const safe = /sql|database|undefined|exception|syntax|\/var\/|secret|configured/i.test(next) ? 'Something went wrong. Your entries have been kept—please try again.' : next;
            value = safe;
            show(safe);
          }
        }
      });
    }
  };
  extend(Page.prototype, 'oninit', installFeedback);
  extend(Modal.prototype, 'oninit', installFeedback);
  const main = 'https://thehideoutcommunity.com';
  extend(HeaderPrimary.prototype, 'items', function (items) {
    const external = (href, label, icon) => m('a', {
      className: 'Button Button--link HideoutNavLink',
      href
    }, m('i', {
      className: icon,
      'aria-hidden': true
    }), m('span', {
      className: 'Button-label'
    }, label));
    items.add('hideout-home', external(main + '/home', 'Home', 'fas fa-home'), 50);
    items.add('hideout-servers', external(main + '/servers', 'Servers', 'fas fa-server'), 45);
    items.add('hideout-events', external(main + '/events', 'Events', 'fas fa-calendar'), 40);
    items.add('hideout-games', m('details.HideoutGamesMenu', {
      onkeydown: event => {
        if (event.key === 'Escape') {
          event.currentTarget.removeAttribute('open');
          event.currentTarget.querySelector('summary')?.focus();
        }
      }
    }, m('summary.Button.Button--link.HideoutNavLink', m('span', 'Games'), m('span', {
      'aria-hidden': true
    }, ' ▾')), m('div.HideoutGamesOptions', external(main + '/rankings', 'CS2 Surf rankings', 'fas fa-trophy'), external(main + '/maps', 'Surf maps', 'fas fa-map'), external(main + '/gmod', 'GMod Hide & Seek', 'fas fa-gamepad'))), 35);
    items.add('hideout-forums', external(app.forum.attribute('baseUrl'), 'Forums', 'fas fa-comments'), 30);
    items.add('hideout-applications', external(main + '/applications', 'Applications', 'fas fa-clipboard-list'), 25);
    items.add('hideout-help', external(main + '/help', 'Help', 'fas fa-question-circle'), 22);
    items.add('hideout-store', external(main + '/store', 'Store', 'fas fa-store'), 20);
    const links = [['/home', 'Home'], ['/servers', 'Servers'], ['/events', 'Events'], ['/rankings', 'Surf rankings'], ['/maps', 'Surf maps'], ['/commands', 'Surf commands'], ['/gmod', 'GMod'], ['/applications', 'Applications'], ['/help', 'Help'], ['/store', 'Store']];
    items.add('hideout-compact-nav', m('details.HideoutCompactMenu', {
      onkeydown: e => {
        if (e.key === 'Escape') {
          e.currentTarget.removeAttribute('open');
          e.currentTarget.querySelector('summary').focus();
        }
      }
    }, m('summary.Button.Button--link', {
      'aria-label': 'Navigation menu'
    }, 'Menu ▾'), m('nav.HideoutCompactOptions', {
      'aria-label': 'Community navigation'
    }, links.map(_ref => {
      let [path, label] = _ref;
      return external(main + path, label, '');
    }), external(app.forum.attribute('baseUrl'), 'Forums', ''), external(app.forum.attribute('baseUrl') + '/punishments', 'Punishments', ''))), 60);
  });
  extend(IndexPage.prototype, 'navItems', function (items) {
    const tags = app.store.all('tags');
    for (const tag of tags) items.remove('tag' + tag.id());
    const parent = tag => typeof tag.parent === 'function' ? tag.parent() : null;
    const order = (a, b) => (a.position?.() ?? 999) - (b.position?.() ?? 999) || a.name().localeCompare(b.name());
    const roots = tags.filter(t => !parent(t)).sort(order);
    const link = function (tag, child) {
      if (child === void 0) {
        child = false;
      }
      return m("a", {
        className: 'HideoutCategoryLink' + (child ? ' HideoutCategoryChild' : ''),
        href: app.forum.attribute('baseUrl') + '/t/' + tag.slug(),
        "aria-current": location.pathname === '/t/' + tag.slug() ? 'page' : undefined
      }, m("i", {
        "aria-hidden": "true",
        className: tag.icon?.() || 'fas fa-comments'
      }), m("span", null, tag.name()));
    };
    items.add('hideout-categories', m("div", {
      className: "HideoutExpandedCategories",
      "aria-label": "Forum categories"
    }, roots.map(tag => m("section", {
      key: tag.id()
    }, link(tag), m("div", null, tags.filter(t => parent(t)?.id() === tag.id()).sort(order).map(child => link(child, true)))))), -5);
  });
  const original = app.request.bind(app);
  app.request = function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return original(...args).then(result => {
      const options = args[0] || {};
      if (/POST|PATCH/i.test(options.method || '') && /discussions|posts|staff\/assignment|profile\/banner/.test(options.url || '')) sessionStorage.removeItem(key());
      return result;
    }).catch(error => {
      const status = Number(error?.status || error?.response?.errors?.[0]?.status) || 500;
      const message = status === 401 ? 'Please sign in to continue.' : status === 403 ? 'Your account cannot perform this action.' : status === 422 ? 'Please check your entries and try again.' : status === 429 ? 'Please wait a moment before trying again.' : 'Something went wrong. Your entries have been kept—please try again.';
      if (error?.response) {
        error.response.message = message;
        error.response.errors = [{
          status: String(status),
          detail: message
        }];
      }
      error.message = message;
      show(message);
      throw error;
    });
  };
  // Private per-tab drafts for forum text fields; exclude passwords and credentials.
  const key = () => 'hideout:forum-draft:' + (app.session.user?.id() || 'guest') + ':' + location.pathname;
  const selector = '.Modal input,.Modal textarea,.Modal select,.Composer input,.Composer textarea,.Composer select';
  const fields = () => Array.from(document.querySelectorAll(selector)).filter(el => !['password', 'hidden', 'file'].includes(el.type) && !/secret|password|token|key/i.test(el.name || ''));
  const identity = el => {
    const root = el.closest('.Modal,.Composer');
    return (root?.querySelector('.Modal-title')?.textContent || root?.className || 'editor') + ':' + (el.name || el.id || el.placeholder || el.type) + ':' + Array.from(root?.querySelectorAll('input,textarea,select') || []).indexOf(el);
  };
  const save = () => {
    try {
      const existing = JSON.parse(sessionStorage.getItem(key()) || '[]');
      const current = fields().map(el => ({
        name: identity(el),
        value: el.value,
        checked: el.checked
      }));
      sessionStorage.setItem(key(), JSON.stringify([...existing.filter(item => !current.some(field => field.name === item.name)), ...current]));
    } catch {}
  };
  document.addEventListener('input', event => {
    if (event.target.matches(selector)) save();
  }, true);
  document.addEventListener('change', event => {
    if (event.target.matches(selector)) save();
  }, true);
  const restored = new WeakSet();
  const observer = new MutationObserver(() => {
    let saved = [];
    try {
      saved = JSON.parse(sessionStorage.getItem(key()) || '[]');
    } catch {}
    fields().forEach(el => {
      if (restored.has(el)) return;
      restored.add(el);
      const item = saved.find(s => s.name === identity(el));
      if (!item) return;
      const checked = ['checkbox', 'radio'].includes(el.type);
      if (!checked && el.value) return;
      const proto = el instanceof HTMLSelectElement ? HTMLSelectElement.prototype : el instanceof HTMLTextAreaElement ? HTMLTextAreaElement.prototype : HTMLInputElement.prototype;
      Object.getOwnPropertyDescriptor(proto, checked ? 'checked' : 'value')?.set?.call(el, checked ? Boolean(item.checked) : item.value);
      el.dispatchEvent(new Event(checked || el instanceof HTMLSelectElement ? 'change' : 'input', {
        bubbles: true
      }));
    });
    document.querySelectorAll('.Header-controls button,.Header-controls a').forEach(el => {
      if (!el.getAttribute('aria-label') && !el.textContent.trim()) el.setAttribute('aria-label', el.title || (/bell/.test(el.innerHTML) ? 'Notifications' : /moon|sun/.test(el.innerHTML) ? 'Change colour theme' : /flag/.test(el.innerHTML) ? 'Moderation queue' : 'Search'));
    });
  });
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
}